import { gql } from '@apollo/client';

export const UPDATE_BANKRUPTCY_LEGAL_INFO = gql`
  mutation UpdateBankruptcyLegalInfo(
    $accountId: String!
    $customerId: String!
    $customerResidentialState: String!
    $caseNumber: String!
    $chapter: String!
    $dateFiled: String!
    $withdrawnDismissedDate: String
    $reset: Boolean
    $stage: BankruptcyStage!
  ) {
    updateBankruptcyLegalInfo(
      accountId: $accountId
      customerId: $customerId
      customerResidentialState: $customerResidentialState
      bankruptcyInput: {
        caseNumber: $caseNumber
        chapter: $chapter
        dateFiled: $dateFiled
        reset: $reset
        stage: $stage
        type: SINGLE
        withdrawnDismissedDate: $withdrawnDismissedDate
      }
    ) {
      status
      accountId

      legalInfoResult {
        operation
        success
        message
      }

      statusUpdateResults {
        statuses {
          message
          operation
          reasonCode
          statusCode
          success
        }
        errors {
          operation
          errorCode
          errorMessage
        }
      }

      autopayCancellationResult {
        cancelledScheduleIds
        schedulesFound
        schedulesCancelled
        errors
      }

      paymentCancellationResult {
        cancelledPaymentIds
        paymentsCancelled
        paymentsFound
        errors
      }

      fundingAccountDisableResult {
        accountsDisabled
        accountsFound
        disabledAccountIds
        errors
      }

      ceaseAndDesistResult {
        success
        errors
      }

      statementPreferencesResult {
        success
        isPaperlessStatement
        accountId
        canUpdateStatementPreference
        errors
      }
    }
  }
`;
